export const getDayDisablingStatus = (daysDifference: number) => ({
  isDayDisabled: daysDifference < 1,
  isTwoDaysDisabled: daysDifference < 2,
  isCustomDaysDisabled: daysDifference < 3,
  upperLimit: Math.min(daysDifference, 70),
})
